'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateFileIdsWithThread = undefined;

var _createDeprecatedAsyncAction = require('conversations-async-data/async-action/createDeprecatedAsyncAction');

var _associateFileIdsWithThreadClient = require('../clients/associateFileIdsWithThreadClient');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var _buildResolvedAttachmentsMapFromResponse = require('../../resolved-attachments/operators/buildResolvedAttachmentsMapFromResponse');

/**
 * Create a mapping between file manager file ids and a live chat thread
 *
 * @param {Array<number>} fileIds
 * @param {number} threadId
 * @param {string} sessionId
 * @returns {Promise<Map<number, ResolvedAttachmentRecord>>}
 */
var associateFileIdsWithThread = exports.associateFileIdsWithThread = (0, _createDeprecatedAsyncAction.createDeprecatedAsyncAction)({
  requestFn: _associateFileIdsWithThreadClient.associateFileIdsWithThreadClient,
  actionTypes: _fileUploadsActionTypes.ASSOCIATE_ATTACHMENTS,
  toRecordFn: _buildResolvedAttachmentsMapFromResponse.buildResolvedAttachmentsMapFromResponse
});